const createLicenseModel = (license = {}) => ({
  id: license.id || null,
  name: license.name || '',
  amount: license.amount || 0,
  testId: license.test?.id || '',
  groupId: license.group?.id || '',
  unitId: license.unit?.id || '',
  schoolId: license.school?.id || '',
  classId: license.student_class?.id || '',
  enableApplyPhotos: license.enable_apply_photos || false,
  expirationDate: license.expiration_date || '',
  licenseType: license.license_type || 'EDUSYNCH',
  durationInMonths: license.duration_in_months || null,
  licenseDays: license.license_days || null,
  readingAmount: license.reading_amount || 0,
  listeningAmount: license.listening_amount || 0,
  writingAmount: license.writing_amount || 0,
  speakingAmount: license.speaking_amount || 0,
  fullTestAmount: license.full_test_amount || 0,
  readingPracticeAmount: license.reading_practice_amount || 0,
  listeningPracticeAmount: license.listening_practice_amount || 0,
  writingPracticeAmount: license.writing_practice_amount || 0,
  speakingPracticeAmount: license.speaking_practice_amount || 0,
  availableAmount: license.available_amount || 0,
  cefrAmount: license.cefr_amount || 0,
  mcerAmount: license.mcer_amount || 0,
  readingWritingAmount: license.reading_writing_amount || 0,
  readingWritingPracticeAmount: license.reading_writing_practice_amount || 0,
  mathAmount: license.math_amount || 0,
  mathPracticeAmount: license.math_practice_amount || 0,
  photoStudent: license.photo_student || false,
  photoUploadId: license.photo_upload_id || false,
  photoUploadType: license.photo_upload_type || false,
  takePictureNextId: license.take_picture_next_id || false,
  screenShare: license.screen_share || false,
  roomScan360: license.room_scan_360 || false,
  roomScanRandom: license.room_scan_random || false,
  enableUserScreenRecording: license.enable_user_screen_recording || false,
  enableUserVideoRecording: license.enable_user_video_recording || false,
  enableUserAudioRecording: license.enable_user_audio_recording || false,
  useActivationDate: license.use_activation_date || false,
  useFirstSignIn: license.use_first_sign_in || false,
});

const createLicenseCustomTestModel = (license = {}) => {
  return {
    id: license.id || null,
    name: license.name || '',
    amount: license.amount || 0,
    customTestId: license.custom_test?.id || '',
    whitelabel: license.whitelabel?.name || '',
    whitelabelId: license.whitelabel?.id || '',
    groupId: license.group?.id || '',
    unitId: license.unit?.id || '',
    schoolId: license.school?.id || '',
    classId: license.student_class?.id || '',
    enableApplyPhotos: license.enable_apply_photos || false,
    expirationDate: license.expiration_date || '',
    licenseType: license.license_type || 'EDUSYNCH',
    readingAmount: license.reading_amount || 0,
    listeningAmount: license.listening_amount || 0,
    writingAmount: license.writing_amount || 0,
    speakingAmount: license.speaking_amount || 0,
    fullTestAmount: license.full_test_amount || 0,
    readingPracticeAmount: license.reading_practice_amount || 0,
    listeningPracticeAmount: license.listening_practice_amount || 0,
    writingPracticeAmount: license.writing_practice_amount || 0,
    speakingPracticeAmount: license.speaking_practice_amount || 0,
    availableAmount: license.available_amount || 0,
    cefrAmount: license.cefr_amount || 0,
    mcerAmount: license.mcer_amount || 0,
    readingWritingAmount: license.reading_writing_amount || 0,
    readingWritingPracticeAmount: license.reading_writing_practice_amount || 0,
    mathAmount: license.math_amount || 0,
    mathPracticeAmount: license.math_practice_amount || 0,
    customCategoriesAmount: license.custom_categories_amount || [],
    photoStudent: license.photo_student || false,
    photoUploadId: license.photo_upload_id || false,
    photoUploadType: license.photo_upload_type || false,
    takePictureNextId: license.take_picture_next_id || false,
    screenShare: license.screen_share || false,
    roomScan360: license.room_scan_360 || false,
    roomScanRandom: license.room_scan_random || false,
    enableUserScreenRecording: license.enable_user_screen_recording || false,
    enableUserVideoRecording: license.enable_user_video_recording || false,
    enableUserAudioRecording: license.enable_user_audio_recording || false,
    useActivationDate: license.use_activation_date || false,
    useFirstSignIn: license.use_first_sign_in || false,
    durationInMonths: license.duration_in_months || null,
    licenseDays: license.license_days || null,
  };
};

const createLicenseProctoringModel = (license = {}) => ({
  id: license.id || null,
  name: license.name || '',
  proctoring_amount_max: license.proctoring_amount_max || 0,
  expiration_date: license.expiration_date || '',
  license_type: license.license_type || 'EDUSYNCH',
  product: license.product || 'proctoring',
  key_type: license.key_type || 'student',
  external_application_id: license.external_application?.id || '',
  eproctoring_license_type: license.eproctoring_license_type || 'per_student',
});

const createLicenseRequestModel = (license = {}) => {
  const licenseRequest = {
    id: license.id,
    name: license.name,
    amount: license.amount,
    test_id: license.testId,
    group_id: license.groupId,
    unit_id: license.unitId,
    school_id: license.schoolId,
    student_class_id: license.classId,
    enable_apply_photos: license.enableApplyPhotos,
    expiration_date: license.expirationDate,
    duration_in_months: license.durationInMonths,
    license_days: license.licenseDays,
    license_type: license.licenseType,
    reading_amount: license.readingAmount,
    listening_amount: license.listeningAmount,
    writing_amount: license.writingAmount,
    speaking_amount: license.speakingAmount,
    full_test_amount: license.fullTestAmount,
    reading_practice_amount: license.readingPracticeAmount,
    listening_practice_amount: license.listeningPracticeAmount,
    writing_practice_amount: license.writingPracticeAmount,
    speaking_practice_amount: license.speakingPracticeAmount,
    available_amount: license.availableAmount,
    cefr_amount: license.cefrAmount,
    mcer_amount: license.mcerAmount,
    reading_writing_amount: license.readingWritingAmount,
    reading_writing_practice_amount: license.readingWritingPracticeAmount,
    math_amount: license.mathAmount,
    math_practice_amount: license.mathPracticeAmount,
    photo_student: license.photoStudent,
    photo_upload_id: license.photoUploadId,
    photo_upload_type: license.photoUploadType,
    take_picture_next_id: license.takePictureNextId,
    screen_share: license.screenShare,
    room_scan_360: license.roomScan360,
    room_scan_random: license.roomScanRandom,
    enable_user_screen_recording: license.enableUserScreenRecording,
    enable_user_video_recording: license.enableUserVideoRecording,
    enable_user_audio_recording: license.enableUserAudioRecording,
    use_activation_date: license.useActivationDate,
    use_first_sign_in: license.useFirstSignIn,
  };

  if (!licenseRequest.use_activation_date) {
    delete licenseRequest.use_activation_date;
  }

  // license_days is the duration of "Use Activation Date" and of "Use First Sign-in". Dropping it for the
  // second one left the API without the days, so the license never got an expiration after the first login.
  if (
    !licenseRequest.use_activation_date &&
    !licenseRequest.use_first_sign_in
  ) {
    delete licenseRequest.license_days;
  }

  if (licenseRequest.use_first_sign_in) {
    delete licenseRequest.expiration_date;
  }

  if (
    !licenseRequest.use_activation_date &&
    !licenseRequest.use_first_sign_in &&
    licenseRequest.license_type !== 'SUBSCRIPTION'
  ) {
    delete licenseRequest.duration_in_months;
  }

  return licenseRequest;
};

const createLicenseProctoringRequestModel = (license = {}) => {
  const licenseRequest = {
    id: license.id,
    name: license.name,
    proctoring_amount_max: license.proctoring_amount_max,
    expiration_date: license.expiration_date,
    license_type: license.license_type,
    product: license.product,
    key_type: license.key_type,
    external_application_id:
      license.external_application?.id || license.external_application_id,
    eproctoring_license_type: license.eproctoring_license_type,
    use_activation_date: license.useActivationDate,
    duration_in_months: license.durationInMonths,
  };

  if (!licenseRequest.use_activation_date) {
    delete licenseRequest.duration_in_months;
    delete licenseRequest.license_days;
    delete licenseRequest.use_activation_date;
  }

  return licenseRequest;
};

const createLicenseCustomTestRequestModel = (license = {}) => {
  const licenseRequest = {
    id: license.id,
    name: license.name,
    amount: license.amount,
    custom_test_id: license.customTestId,
    group_id: license.groupId,
    whitelabel_id: license.whitelabelId,
    unit_id: license.unitId,
    school_id: license.schoolId,
    student_class_id: license.classId,
    enable_apply_photos: license.enableApplyPhotos,
    expiration_date: license.expirationDate,
    duration_in_months: license.durationInMonths,
    license_days: license.licenseDays,
    license_type: license.licenseType,
    reading_amount: license.readingAmount,
    listening_amount: license.listeningAmount,
    writing_amount: license.writingAmount,
    speaking_amount: license.speakingAmount,
    full_test_amount: license.fullTestAmount,
    reading_practice_amount: license.readingPracticeAmount,
    listening_practice_amount: license.listeningPracticeAmount,
    writing_practice_amount: license.writingPracticeAmount,
    speaking_practice_amount: license.speakingPracticeAmount,
    available_amount: license.availableAmount,
    cefr_amount: license.cefrAmount,
    mcer_amount: license.mcerAmount,
    reading_writing_amount: license.readingWritingAmount,
    reading_writing_practice_amount: license.readingWritingPracticeAmount,
    math_amount: license.mathAmount,
    math_practice_amount: license.mathPracticeAmount,
    custom_categories_amount: license.customCategoriesAmount,
    photo_student: license.photoStudent,
    photo_upload_id: license.photoUploadId,
    photo_upload_type: license.photoUploadType,
    take_picture_next_id: license.takePictureNextId,
    screen_share: license.screenShare,
    room_scan_360: license.roomScan360,
    room_scan_random: license.roomScanRandom,
    enable_user_screen_recording: license.enableUserScreenRecording,
    enable_user_video_recording: license.enableUserVideoRecording,
    enable_user_audio_recording: license.enableUserAudioRecording,
    use_activation_date: license.useActivationDate,
    use_first_sign_in: license.useFirstSignIn,
  };

  if (!licenseRequest.use_activation_date) {
    delete licenseRequest.duration_in_months;
    delete licenseRequest.use_activation_date;
  }

  if (
    !licenseRequest.use_activation_date &&
    !licenseRequest.use_first_sign_in
  ) {
    delete licenseRequest.license_days;
  }

  if (licenseRequest.use_first_sign_in) {
    delete licenseRequest.expiration_date;
  }

  return licenseRequest;
};

const licenseProctoringTypes = [
  {
    id: 'per_student',
    name: 'Student',
  },
  {
    id: 'per_session',
    name: 'Session',
  },
];

const licenseTypes = [
  {
    id: 'EDUSYNCH',
    name: 'EduSynch',
  },
  {
    id: 'SUBSCRIPTION',
    name: 'Subscription',
  },
];

const DEFAULT_LICENSE_TYPE = 'EDUSYNCH';
const LICENSE_TYPE_SUBSCRIPTION = 'SUBSCRIPTION';

const DEFAULT_PROCTORING_FIELDS = [
  'photoStudent',
  'photoUploadId',
  'photoUploadType',
  'screenShare',
  'takePictureNextId',
  'roomScan360',
  'roomScanRandom',
  'enableUserScreenRecording',
  'enableUserVideoRecording',
  'enableUserAudioRecording',
];

export {
  createLicenseModel,
  createLicenseCustomTestModel,
  createLicenseProctoringModel,
  createLicenseRequestModel,
  createLicenseProctoringRequestModel,
  createLicenseCustomTestRequestModel,
  licenseProctoringTypes,
  licenseTypes,
  DEFAULT_LICENSE_TYPE,
  DEFAULT_PROCTORING_FIELDS,
  LICENSE_TYPE_SUBSCRIPTION,
};
